import React from "react";
import { signOutUseCase } from "../../usecases/user";
import BasePage from "../../base/BasePage";

class ExpiredPage extends BasePage {
  constructor(props) {
    super(props);
    this.signOutUseCase = signOutUseCase();
  }

  onClickLogout() {
    // this.signOutUseCase.execute().then(() => {
    //   this.navigateTo("/signin");
    // });
    window.history.back();
  }

  render() {
    return (
      <div className="vh-100 d-flex align-items-center bg-light">
        <div className="container text-center w-50">
          <div className="mb-4">
            <i
              className="bi bi-tools spinning-icon"
              style={{ fontSize: "4rem", color: "#e09552" }}
            ></i>
          </div>
          <h1>This page is under construction.</h1>
          <p>We're working hard to finish it for you!</p>
          <button
            className="btn btn-primary mt-3"
            onClick={this.onClickLogout.bind(this)}
          >
            Back
          </button>
        </div>
      </div>
    );
  }
}

export default ExpiredPage;
